export default __webpack_public_path__ + "static/media/user-transformed.3b3f3ef1.png";